export default __webpack_public_path__ + "static/media/zeit.97f76377.svg";